


import { Map as IMap, List as IList } from 'immutable';

import { checkoutStartedSegmentData } from '../segment/segmentSelectors';


export const E_CARD_TYPE = 'eGiftCards';
export const PHYSICAL_CARD_TYPE = 'physicalCards';


export const ADD_ITEM = '@@storefront/ADD_ITEM';
export const HANDLE_ADD_BUY_NOW_ITEM = '@@storefront/HANDLE_ADD_BUY_NOW_ITEM';
export const HANDLE_REMOVE_BUY_NOW_ITEM = '@@storefront/HANDLE_REMOVE_BUY_NOW_ITEM';
export const FLUSH_PRODUCT_DETAILS = '@@storefront/FLUSH_PRODUCT_DETAILS';
export const UPDATE_ITEM = '@@storefront/UPDATE_ITEM';
export const REMOVE_ITEM = '@@storefront/REMOVE_ITEM';
export const SAVE_NEW_ITEM_TO_CART = '@@storefront/SAVE_NEW_ITEM_TO_CART';
export const SET_GRAND_TOTAL = '@@storefront/SET_GRAND_TOTAL';
export const RUN_AMOUNT_CALCULATIONS = '@@storefront/RUN_AMOUNT_CALCULATIONS';
export const SET_CONSUMER_FEE_DETAILS = '@@storefront/SET_CONSUMER_FEE_DETAILS';
export const SET_E_GREETING_CARD_TOTAL = '@@storefront/SET_E_GREETING_CARD_TOTAL';
export const HANDLE_SENDER_DETAILS_UPDATE = '@@storefront/HANDLE_SENDER_DETAILS_UPDATE';
export const UPDATE_SHIPPING_COST_IN_CART = '@@storefront/UPDATE_SHIPPING_COST_IN_CART';
export const SET_ORDER_NUMBER = '@@storefront/SET_ORDER_NUMBER';
export const SET_CART_RESUME_DONE = '@@storefront/SET_CART_RESUME_DONE';


const productCartReducer = (state = IMap({ totalActiveCards: 0 }), action) => {
    switch (action.type) {
        case ADD_ITEM: {
            if (action.skipCart) {
                
                return state.merge(action.data);
            }

            const newCurrencyCode = action.data.get('currencyCode', null);
            let newState = state;

            
            if (
                state.get('currencyCode', false)
                && state.get('currencyCode') !== newCurrencyCode
                && !!state.get('totalActiveCards', 0)
            ) {
                return state;
            }
            newState = newState.set('currencyCode', newCurrencyCode);

            let activeCardsCount = state.get('totalActiveCards', 0);

            
            if (action.data.has(E_CARD_TYPE)) {
                const updatedECardTypeList = newState
                    .get(E_CARD_TYPE, IList())
                    .concat(action.data.get(E_CARD_TYPE));
                newState = newState.set(E_CARD_TYPE, updatedECardTypeList);
                activeCardsCount += action.data.get(E_CARD_TYPE).size;
            }

            
            if (action.data.has(PHYSICAL_CARD_TYPE)) {
                const updatedPhysicalCardList = newState
                    .get(PHYSICAL_CARD_TYPE, IList())
                    .concat(action.data.get(PHYSICAL_CARD_TYPE));
                newState = newState.set(PHYSICAL_CARD_TYPE, updatedPhysicalCardList);
                activeCardsCount += action.data.get(PHYSICAL_CARD_TYPE).size;
            }

            return newState.set('totalActiveCards', activeCardsCount);
        }
        case UPDATE_ITEM: {
            
            
            
            let newState = state;
            [E_CARD_TYPE, PHYSICAL_CARD_TYPE].forEach((cardType) => {
                if (newState.has(cardType)) {
                    const updatedItems = newState.get(cardType).map((item) => {
                        if (item.get('id') === action.itemUpdates.get('id')) {
                            const wasRemoved = item.get('removed', false);
                            const willBeRemoved = action.itemUpdates.has('removed')
                                ? action.itemUpdates.get('removed') : wasRemoved;

                            if (wasRemoved !== willBeRemoved) {
                                if (!willBeRemoved) {
                                    
                                    newState = newState.set(
                                        'totalActiveCards', newState.get('totalActiveCards', 0) + 1
                                    );
                                } else if (willBeRemoved) {
                                    
                                    newState = newState.set(
                                        'totalActiveCards', Math.max(0, newState.get('totalActiveCards', 0) - 1)
                                    );
                                }
                            }
                            return item.mergeDeep(action.itemUpdates);
                        }
                        return item;
                    });

                    newState = newState.set(cardType, updatedItems);
                }
            });

            return newState;
        }
        case HANDLE_SENDER_DETAILS_UPDATE: {
            let newState = state;
            [E_CARD_TYPE, PHYSICAL_CARD_TYPE].forEach((cardType) => {
                if (newState.has(cardType)) {
                    const updatedItems = newState.get(cardType).map((item) => {
                        const updates = item.get('selfBuy') === true
                            ? {
                                yourName: action.updatedSenderName,
                                yourEmail: action.updatedSenderEmail
                            }
                            : {
                                senderName: action.updatedSenderName,
                                senderEmail: action.updatedSenderEmail
                            };

                        return item.merge(updates);
                    });

                    newState = newState.set(cardType, updatedItems);
                }
            });

            return newState;
        }
        case REMOVE_ITEM: {
            if (!state.get('totalActiveCards', 0)) {
                
                
                return state;
            }

            let activeCardsCount = state.get('totalActiveCards');
            const updatedItems = state.get(action.cardType).map((item) => {
                if (item.get('id') === action.id) {
                    activeCardsCount -= 1;
                    return item.set('removed', true);
                }
                return item;
            });

            return state.set(action.cardType, updatedItems)
                .set('totalActiveCards', activeCardsCount);
        }
        case SET_GRAND_TOTAL: {
            return state.set('grandTotal', action.amount);
        }
        case SET_CONSUMER_FEE_DETAILS: {
            return state.set('activationFeeTotal', action.total)
                .set('activationFeeCount', action.count)
                .set('uyoFeeTotal', action.uyoTotal)
                .set('uyoFeeCount', action.uyoCount);
        }
        case SET_E_GREETING_CARD_TOTAL: {
            return state.set('eGreetingCardTotal', action.total);
        }
        case SET_ORDER_NUMBER: {
            return state.set('orderNumber', action.orderNumber);
        }
        
        case FLUSH_PRODUCT_DETAILS: {
            return state.clear();
        }
        case HANDLE_ADD_BUY_NOW_ITEM: {
            let newState = state;
            newState = newState.set('buyNowItem', action.data);

            return newState;
        }
        case HANDLE_REMOVE_BUY_NOW_ITEM: {
            let newState = state;
            newState = newState.delete('buyNowItem');

            return newState;
        }
        case UPDATE_SHIPPING_COST_IN_CART: {
            const { token, shippingCost } = action.payload;
            let newState = state;
            const physicalCards = newState.get(PHYSICAL_CARD_TYPE, IList());
            const updatedPhysicalCards = physicalCards.map((item) => {
                const shippingAddress = item.get('shippingAddress');
                const shippingAddressToken = shippingAddress && typeof shippingAddress === 'object'
                    ? shippingAddress.get('token')
                    : undefined;
                if (shippingAddressToken === token) {
                    const updatedShippingAddress = shippingAddress.set('amount', shippingCost);
                    return item.set('shippingAddress', updatedShippingAddress);
                }
                return item;
            });
            newState = newState.set(PHYSICAL_CARD_TYPE, updatedPhysicalCards);
            const buyNowItem = newState.get('buyNowItem');
            if (buyNowItem && buyNowItem.get(PHYSICAL_CARD_TYPE)) {
                const updatedBuyNowPhysicalCards = buyNowItem.get(PHYSICAL_CARD_TYPE).map((item) => {
                    const shippingAddress = item.get('shippingAddress');
                    const shippingAddressToken = shippingAddress && typeof shippingAddress === 'object'
                        ? shippingAddress.get('token')
                        : undefined;
                    if (shippingAddressToken === token) {
                        const updatedShippingAddress = shippingAddress.set('amount', shippingCost);
                        return item.set('shippingAddress', updatedShippingAddress);
                    }
                    return item;
                });
                newState = newState.set(
                    'buyNowItem',
                    buyNowItem.set(PHYSICAL_CARD_TYPE, updatedBuyNowPhysicalCards)
                );
            }
            return newState;
        }
        case SET_CART_RESUME_DONE:
            return state.set('cartResumeDone', action.payload);
        default:
    }
    return state;
};


export const addItemInCart = (products, skipCart = false) => ({
    type: ADD_ITEM,
    data: products,
    skipCart,
    meta: {
        ...(skipCart && {
            segment: {
                eventAction: 'Checkout Started',
                
                eventData: checkoutStartedSegmentData(products.toJS())
            }
        })
    }
});

export const removeItemFromCart = (id, cardType) => ({
    type: REMOVE_ITEM,
    id,
    cardType
});

export const updateItemInCart = itemUpdates => ({
    type: UPDATE_ITEM,
    itemUpdates
});

export const updateSenderDetails = (updatedSenderName, updatedSenderEmail, shouldCallApply) => ({
    type: HANDLE_SENDER_DETAILS_UPDATE,
    updatedSenderName,
    updatedSenderEmail,
    shouldCallApply
});

export const saveNewItemToCart = newItem => ({
    type: SAVE_NEW_ITEM_TO_CART,
    newItem
});

export const setGrandTotal = amount => ({
    type: SET_GRAND_TOTAL,
    amount
});

export const runAmountCalculations = () => ({
    type: RUN_AMOUNT_CALCULATIONS
});

export const setConsumerFeeDetails = (total, count, uyoTotal = 0, uyoCount = 0) => ({
    type: SET_CONSUMER_FEE_DETAILS,
    total,
    count,
    uyoTotal,
    uyoCount
});

export const setEGreetingCardTotal = total => ({
    type: SET_E_GREETING_CARD_TOTAL,
    total
});

export const setOrderNumber = orderNumber => ({
    type: SET_ORDER_NUMBER,
    orderNumber
});


export const flushProductDetails = () => ({
    type: FLUSH_PRODUCT_DETAILS
});

export const handleAddBuyNowItem = buyNowItem => ({
    type: HANDLE_ADD_BUY_NOW_ITEM,
    data: buyNowItem
});

export const handleRemoveBuyNowItem = () => ({
    type: HANDLE_REMOVE_BUY_NOW_ITEM
});


export default productCartReducer;


export const updateShippingCostInCart = (token, shippingCost) => ({
    type: UPDATE_SHIPPING_COST_IN_CART,
    payload: { token, shippingCost }
});


export const setCartResumeDone = hasItems => ({
    type: SET_CART_RESUME_DONE,
    payload: hasItems
});
